import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import firebase from 'firebase/app';

@Pipe({ name: 'timeFromNow' })
export class TimefromnowPipe implements PipeTransform {

  transform(value: firebase.firestore.Timestamp): string {
    if (value === null) {
      return 'unknown';
    }

    const momentDate = moment(value.toDate());
    if (momentDate.isValid()) {
      return momentDate.fromNow();
    } else {
      return 'N / A';
    }

  }
}
